// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M8gek","button":"styles_button__k06M8","icon":"styles_icon__N4vZD","slide-in-out":"styles_slide-in-out__V2koK","fade-in-out":"styles_fade-in-out__jpXls"};